import FBSubright from "../FBSubright";
import stringToHash from "../../data/dataUtils";

class FBSubrightBuilder {
  static buildFBSubright(description, organizations, title, rightsCategoryID) {
    if (
      description == null ||
      organizations == null ||
      title == null ||
      rightsCategoryID == null
    ) {
      return null;
    }
    if (
      typeof description !== "string" ||
      typeof title != "string" ||
      !Array.isArray(organizations) ||
      typeof rightsCategoryID !== "string"
    ) {
      return null;
    }

    const orgIDs = organizations.map((org) => org.id);
    // This exists for legacy purposes and should be removed later.
    const categoryIDs = [rightsCategoryID];
    const titleHash = stringToHash(title);
    const descriptionHash = stringToHash(description);
    return new FBSubright(
      description,
      orgIDs,
      title,
      categoryIDs,
      rightsCategoryID,
      titleHash,
      descriptionHash
    );
  }

  static buildJSONToPush(fbSubright) {
    return {
      categoryIDs: fbSubright.categoryIDs,
      description: fbSubright.descriptionHash,
      learnMores: fbSubright.learnMores,
      organizations: fbSubright.organizations,
      title: fbSubright.titleHash,
      rightsCategoryID: fbSubright.rightsCategoryID,
    };
  }
}

export default FBSubrightBuilder;
